import type { StoreTeam } from "@coworker/types/lib/storeteam";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "../../constants/clientTime";
import { getStoreTeams } from "../../hooks/API/core.service";
import { useStoreId, useTeamId } from "../auth/useLoggedInUser";

export function useStoreTeamsQuery() {
  const storeId = useStoreId();
  return useQuery<StoreTeam[]>({
    queryKey: ["storeTeams", storeId],
    queryFn: async () => await getStoreTeams(storeId),
    enabled: !!storeId,
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
  });
}

export function useStoreTeams() {
  const result = useStoreTeamsQuery();
  return (result?.data as StoreTeam[]) ?? [];
}

export function useTeamsByStore(
  storeId: string | null,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const result = useQuery<StoreTeam[]>({
    queryKey: ["storeTeams", storeId],
    queryFn: async () => await getStoreTeams(storeId),
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
    enabled: Boolean(storeId) && enabled,
  });
  return result;
}

export function useMyTeam() {
  const teamId = useTeamId();
  return useStoreTeams().find((team: StoreTeam) => team.id === teamId);
}
